var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newReportViewConfiguration(data) {
    var instance = {
        __type: "ReportViewConfiguration:#DecisionsFramework.Design.Report.Service.Comunication",
        IncludeAllPagesInMultiSelection: false,
        CultureName: null,
        Columns: null,
        Groups: null,
        Sorts: null,
        RowsPerPage: null,
        UsePaging: null,
        FilterValues: null,
        CanAddColumns: null,
        CanAddMultipleColumns: false,
        AddColumnsOption: null,
        TextFilter: null,
        ResetTextFilter: false,
        FilterMode: 0 /* FilterMode.Off */,
        LimitMatrixRowsAndColumns: null,
        MatrixMaxRows: null,
        MatrixMaxColumns: null,
        MaxReportRows: null,
        Timestamp: 0,
        SaveGridSettings: false,
        SaveGridSettingsForAnyFolder: false,
        ComponentId: null,
        PageId: null,
        UserCharts: null,
        PreviewWidth: null,
        PreviewHeight: null,
        ActionHeight: null,
        PageContextId: null,
        ClearContextBasedOnFolderVisiblity: true,
        ShowActionsOnRightClick: false,
        ShowActionsOnLeftClick: false,
        ColumnFlow: null,
        IsDraggable: false
    };
    return __assign(__assign({}, instance), data);
}
export function isReportViewConfiguration(object) {
    return object.__type === "ReportViewConfiguration:#DecisionsFramework.Design.Report.Service.Comunication";
}
